export class ListOfKSTResponse {
	bezeichnung: string;
	id: number;
	nummer: string;
}
